import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cn } from "../ClassName";

interface IconButtonProps {
  /**
   * @type string
   * @description Tailwind CSS string to override default styling
   */
  className?: string;
  /**
   * @type String
   * @description Fontawesome icon string.
   * @example "fas fa-check"
   */
  icon?: string;
  fontAwesomeIcon?: any;
  /**
   * @type (e) => void
   * @description Function to be called on clicking the button.
   */
  onClick: (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent> | React.KeyboardEvent,
  ) => void;
  /**
   * @description Pass this prop to render a disabled button.
   */
  disabled?: boolean;

  /**
   * @description Pass this prop to allow the button to be navigated to using the keyboard.
   */
  disableTabNavigation?: boolean;
}

/**
 * @description
 * Required props: `icon`, `onClick`
 *
 * Optional props: `className`, `disabled`
 */
export function IconButton(props: IconButtonProps) {
  return (
    <button
      tabIndex={props.disableTabNavigation ? -1 : 0}
      className={cn("icon-btn", props.className)}
      onClick={(e) => props.onClick(e)}
      disabled={props.disabled}
    >
      {props.icon ? (
        <i className={`${props.icon}`} />
      ) : (
        <FontAwesomeIcon icon={props.fontAwesomeIcon} />
      )}
    </button>
  );
}
